import * as React from 'react';

import CourseraPlusUpsellCard from 'bundles/unified-description-page-common/components/modules/upsell/CourseraPlusUpsellCard';
import DegreeUpsellCard from 'bundles/unified-description-page-common/components/modules/upsell/DegreeUpsellCard';
import EnterpriseUpsellCard from 'bundles/unified-description-page-common/components/modules/upsell/EnterpriseUpsellCard';
import UpsellModule from 'bundles/unified-description-page-common/components/modules/upsell/UpsellModule';
import { useIsEnterpriseLearner } from 'bundles/unified-description-page-common/contexts/UserContext';
import { useCourseraPlusOwnership } from 'bundles/unified-description-page-common/contexts/consumer/CourseraPlusOwnershipContext';
import { UpsellCardNames } from 'bundles/unified-description-page-common/types/moduleConfig';

type Props = {
  config: { upsellCards: Array<(typeof UpsellCardNames)[keyof typeof UpsellCardNames]> };
};

const UpsellModuleRenderer = ({ config }: Props) => {
  const courseraPlusOwnership = useCourseraPlusOwnership();
  const { isEnterpriseLearner, loadingIsEnterpriseLearner } = useIsEnterpriseLearner();

  if (!(config?.upsellCards?.length > 0)) {
    return null;
  }

  const cardsToRender = config.upsellCards.map((cardName) => {
    switch (cardName) {
      case UpsellCardNames.CourseraPlusUpsellCard:
        if (!courseraPlusOwnership?.isSubscribedToCPlusOrLite) {
          return <CourseraPlusUpsellCard />;
        }
        return null;
      case UpsellCardNames.DegreeUpsellCard:
        return <DegreeUpsellCard />;
      case UpsellCardNames.EnterpriseUpsellCard:
        if (!loadingIsEnterpriseLearner && !isEnterpriseLearner) {
          return <EnterpriseUpsellCard />;
        }
        return null;
      default:
        return null;
    }
  });

  return <UpsellModule cards={cardsToRender.filter((card) => card !== null)} />;
};

export default UpsellModuleRenderer;
